<template>
  <div id="PurchasePlanMgmt" class="purchase-plan-mgmt-page purchase-mgmt-page">
    <div ref="header" class="page-header">
      <div class="filter-card header-box">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">视图类型</span>
            <el-select placeholder="视图类型" size="small" v-model="params.viewType">
              <el-option label="SKU" value="1"></el-option>
              <el-option label="产品" value="2"></el-option>
              <el-option label="产品-颜色" value="3"></el-option>
              <el-option label="机型" value="4"></el-option>
              <el-option label="产品-机型" value="5"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品类型</span>
            <el-select placeholder="全部" size="small" v-model="params.productType" filterable clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品颜色</span>
            <el-select placeholder="全部" size="small" v-model="params.productColor" filterable clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">机型</span>
            <el-select placeholder="全部" size="small" v-model="productModel" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="model in modelList" :key="model" :label="model" :value="model"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">SKU</span>
            <el-input placeholder="请输入SKU" size="small" clearable v-model="params.sku" class="filter-input-wide"></el-input>
          </div>
          <div class="filter-item">
            <span class="filter-label">采购状态</span>
            <el-select placeholder="全部" size="small" v-model="params.purchaseStatus" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="需要采购" :value="1"></el-option>
              <el-option label="无需采购" :value="0"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">排序类型</span>
            <el-select placeholder="请选择" size="small" v-model="params.sortKey">
              <el-option label="应采购" value="planPurchase"></el-option>
              <el-option label="本地库存" value="localInventory"></el-option>
              <el-option label="应补货" value="planOutStockCount"></el-option>
              <el-option label="可补货" value="enableOutStockCount"></el-option>
              <el-option label="亚马逊库存天数" value="inventoryDay"></el-option>
              <el-option label="可用库存天数" value="availableInventoryDay"></el-option>
              <el-option label="7日访客" value="last7DayVisits"></el-option>
              <el-option label="90日访客" value="last90DayVisits"></el-option>
              <el-option label="7日订单" value="last7DayOrderItems"></el-option>
              <el-option label="90日订单" value="last90DayOrderItems"></el-option>
              <el-option label="亚马逊库存" value="inventoryCount"></el-option>
              <el-option label="采购手工调整" value="planPurchaseAdjust"></el-option>
              <el-option label="日销量手工调整" value="manualDayOrderAdjust"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">增速排序</span>
            <el-select placeholder="请选择" size="small" v-model="params.sortType">
              <el-option label="升序" value="1"></el-option>
              <el-option label="降序" value="-1"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">视图模式</span>
            <el-select placeholder="请选择" size="small" v-model="viewModel">
              <el-option label="精简" :value="1"></el-option>
              <el-option label="全量" :value="2"></el-option>
            </el-select>
          </div>
          <div class="filter-item">
            <span class="toolbar-tip">共 {{ total }} 条</span>
          </div>
        </div>
        <div class="filter-toolbar">
          <div class="filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="queryBtn">查询</el-button>
            <el-button type="primary" size="small" plain @click="openCreateInventoryDialog">生成计划</el-button>
            <el-button v-if="funType == 'outStock'" type="primary" size="small" plain @click="openCreateOutStockDialog">生产出库单</el-button>
            <el-button v-if="funType == 'purchase' && multipleSelection.length > 0" type="primary" size="small" @click="addPurchase">加入采购</el-button>
            <el-button v-if="funType == 'purchase' && multipleSelection.length > 0" type="primary" size="small" @click="addPurchaseRecord">加入采购记录</el-button>
            <el-button v-if="funType == 'purchase' && multipleSelection.length > 0" type="primary" size="small" plain @click="batchUpdatePlanPurchaseAdjust">批量修改采购手工调整</el-button>
            <el-button size="small" @click="goDataDictionary">数据字典</el-button>
          </div>
          <div class="batch-toolbar" v-if="funType == 'purchase' && multipleSelection.length > 0">
            <span class="toolbar-tip">已选 {{ multipleSelection.length }} 条</span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table ref="table" :data="tableData" border stripe size="mini" :height="screenHeight" :highlight-current-row="true" class="mgmt-table" header-cell-class-name="table-header-cell" @selection-change="handleSelectionChange" @cell-click="handleCellClick" v-longpress.prevent="handleLongPress" @cell-mouse-enter="handleMouseEnter" show-summary :summary-method="getSummaries" v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading">
          <el-table-column type="selection" width="55" v-if="funType == 'purchase'"></el-table-column>
          <el-table-column v-if="params.viewType == 1" prop="seller-sku" label="SKU" width="200px" align="center" :key="10" fixed sortable> </el-table-column>
          <el-table-column v-if="params.viewType != 4" prop="productName" label="名称" width="120px" align="right" :key="11" fixed sortable> </el-table-column>
          <el-table-column v-if="params.viewType == 1 || params.viewType == 4 || params.viewType == 5" prop="model" label="机型" width="60px" align="right" :key="12" sortable> </el-table-column>
          <el-table-column v-if="params.viewType == 1 || params.viewType == 3" prop="productColorName" label="颜色" width="55px" align="right" :key="13" sortable> </el-table-column>
          <!-- <el-table-column prop="fulfillment-channel" label="类型" width="40px" align="right" v-if="params.viewModel == 2" :key="14" sortable>
        <template v-slot="scope">
          <div class="row-item">{{ scope.row["fulfillment-channel"] && (scope.row["fulfillment-channel"] == "AMAZON_NA"? "FBA":"自发货") }}</div>
        </template>
      </el-table-column> -->

          <el-table-column prop="actualPlanPurchase" label="实际采购" width="50px" align="right" :key="1151" sortable> </el-table-column>
          <el-table-column prop="planPurchaseAdjust" label="采购手工调整" width="50px" align="right" :key="11151" sortable> </el-table-column>
          <el-table-column prop="planPurchase" label="应采购" width="50px" align="right" :key="11512" sortable> </el-table-column>
          <el-table-column prop="inPurchase" label="采购中" width="50px" align="right" :key="1152" sortable> </el-table-column>
          <el-table-column prop="localInventory" label="本地库存" width="50px" align="right" :key="1153" sortable> </el-table-column>

          <el-table-column prop="planOutStockCount" label="应补货" width="50px" align="right" :key="1154" sortable>
            <template v-slot="scope">
              <div class="redText">{{ scope.row.planOutStockCount }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="enableOutStockCount" label="可补货" width="50px" align="right" :key="11551" sortable>
            <template v-slot="scope">
              <div class="redText">{{ scope.row.enableOutStockCount }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="outStockCount" label="出库中" width="50px" align="right" :key="1156" sortable>
            <template v-slot="scope">
              <div class="redText">{{ parseInt(scope.row.outStockCount) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="dayOrderItems" label="日销量" width="55px" align="right" :key="1155" sortable>
            <template v-slot="scope">
              <div>{{ scope.row.dayOrderItems ? scope.row.dayOrderItems.toFixed(2) : "0.00" }}</div>
            </template>
          </el-table-column>
          <el-table-column v-if="params.viewType == 1" prop="manualDayOrderAdjust" label="日销量手工调整" width="50px" align="right" :key="115511" sortable>
            <template v-slot="scope">
              <div>{{ scope.row.manualDayOrderAdjust ? scope.row.manualDayOrderAdjust.toFixed(2) : "0.00" }}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="enableOutStockCount" label="补货物流" width="60px" align="right" :key="12155" sortable>
        <template v-slot="scope">
          <div>{{ getLogisticsTypeLabel(scope.row.logisticsType) }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="params.viewType == 1" prop="stockCycleType" label="备货类型" width="60px" align="right" :key="12156" sortable>
        <template v-slot="scope">
          <div>{{ getStockCycleTypeLabel(scope.row.stockCycleType) }}</div>
        </template>
      </el-table-column> -->
          <template v-if="params.viewType == 1">
            <el-table-column prop="amazonStockCycle" label="亚马逊备货周期" width="50px" align="right" :key="11561" sortable> </el-table-column>
            <el-table-column prop="firstLegStockCycle" label="头程备货周期" width="50px" align="right" :key="11562" sortable> </el-table-column>
            <el-table-column prop="localStockCycle" label="本地备货周期" width="50px" align="right" :key="11563" sortable> </el-table-column>
          </template>

          <el-table-column prop="targetInventoryCount" label="目标库存" width="50px" align="right" :key="11111" sortable> </el-table-column>
          <el-table-column prop="totalAwdUnits" label="AWD库存" width="50px" align="right" :key="321155" sortable> </el-table-column>
          <el-table-column prop="inboundToAwdUnits" label="入库至AWD" width="50px" align="right" :key="11111111" sortable> </el-table-column>
          <el-table-column prop="availableInAwdUnits" label="在AWD中可用" width="50px" align="right" :key="11111222" sortable> </el-table-column>
          <el-table-column prop="outboundToFbaUnits" label="AWD发往FBA" width="50px" align="right" :key="32113355" sortable> </el-table-column>

          <el-table-column prop="allInventory" label="合计库存" width="50px" align="right" :key="111" sortable> </el-table-column>
          <el-table-column prop="inventoryCount" label="亚马逊库存" width="50px" align="right" :key="1111" sortable> </el-table-column>
          <el-table-column prop="availableQuantity" label="可用" width="50px" style="color: green" align="right" :key="112" sortable>
            <template v-slot="scope">
              <div class="redText">{{ scope.row.availableQuantity }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="reservedQuantity" label="预留" width="50px" style="color: greenyellow" align="right" :key="113" sortable>
            <template v-slot="scope">
              <div class="greenYellowText">{{ scope.row.reservedQuantity }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="inboundQuantity" label="入库" width="50px" align="right" :key="114" sortable> </el-table-column>
          <el-table-column prop="availableIn1WeekCount" label="1周内上架" width="50px" align="right" :key="81151" sortable>
            <template v-slot="scope">
              <div>{{ scope.row.availableIn1WeekCount > 0 ? parseInt(scope.row.availableIn1WeekCount) : "--" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="availableIn2WeekCount" label="2周内上架" width="50px" align="right" :key="81152" sortable>
            <template v-slot="scope">
              <div>{{ scope.row.availableIn2WeekCount > 0 ? parseInt(scope.row.availableIn2WeekCount) : "--" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="availableIn3WeekCount" label="3周内上架" width="50px" align="right" :key="81153" sortable>
            <template v-slot="scope">
              <div>{{ scope.row.availableIn3WeekCount > 0 ? parseInt(scope.row.availableIn3WeekCount) : "--" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="availableIn4WeekCount" label="4周内上架" width="50px" align="right" :key="81154" sortable>
            <template v-slot="scope">
              <div>{{ scope.row.availableIn4WeekCount > 0 ? parseInt(scope.row.availableIn4WeekCount) : "--" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="availableIn5WeekCount" label="5周内上架" width="50px" align="right" :key="81155" sortable>
            <template v-slot="scope">
              <div>{{ scope.row.availableIn5WeekCount > 0 ? parseInt(scope.row.availableIn5WeekCount) : "--" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="availableOver5WeekCount" label="超5周上架" width="50px" align="right" :key="81156" sortable>
            <template v-slot="scope">
              <div>{{ scope.row.availableOver5WeekCount > 0 ? parseInt(scope.row.availableOver5WeekCount) : "--" }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="inboundWorking" label="处理中" width="50px" align="right" :key="115" sortable> </el-table-column>
          <el-table-column prop="inboundShipped" label="已发货" width="50px" align="right" :key="116" sortable> </el-table-column>
          <el-table-column prop="inboundReceived" label="正在接收" width="50px" align="right" :key="117" sortable> </el-table-column>
          <el-table-column prop="inventoryDay" label="亚马逊库存天数" width="55px" align="right" :key="118" sortable>
            <template v-slot="scope">
              <div :class="getInventoryDayStyleClass(scope.row)">{{ scope.row.inventoryDay }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="availableInventoryDay" label="可用库存天数" width="55px" align="right" :key="1118" sortable>
            <template v-slot="scope">
              <div :class="getAvailableInventoryDayStyleClass(scope.row)">{{ scope.row.availableInventoryDay }}</div>
            </template>
          </el-table-column>

          <template v-if="viewModel == 2">
            <el-table-column prop="last90DayOrderItems" label="90日订单" width="55px" align="right" :key="15061" sortable> </el-table-column>
            <el-table-column prop="last30DayOrderItems" label="30日订单" width="55px" align="right" :key="15062" sortable> </el-table-column>
            <el-table-column prop="last14DayOrderItems" label="14日订单" width="55px" align="right" :key="15063" sortable> </el-table-column>
          </template>
          <el-table-column prop="last7DayOrderItems" label="7日订单" width="55px" align="right" :key="15064" sortable> </el-table-column>
          <template v-if="viewModel == 2">
            <el-table-column prop="last2DayOrderItems" label="2日订单" width="55px" align="right" :key="15065" sortable> </el-table-column>

            <el-table-column prop="lastDayOrderItems" label="昨日订单" width="55px" align="right" :key="15066" sortable> </el-table-column>

            <el-table-column prop="last90DayVisits" label="90日访客" width="55px" align="right" :key="1501" sortable> </el-table-column>
            <el-table-column prop="last30DayVisits" label="30日访客" width="55px" align="right" :key="1502" sortable> </el-table-column>
            <el-table-column prop="last14DayVisits" label="14日访客" width="55px" align="right" :key="1503" sortable> </el-table-column>
          </template>
          <el-table-column prop="last7DayVisits" label="7日访客" width="55px" align="right" :key="1504" sortable> </el-table-column>
          <template v-if="viewModel == 2">
            <el-table-column prop="last2DayVisits" label="2日访客" width="55px" align="right" :key="1505" sortable> </el-table-column>

            <el-table-column prop="lastDayVisits" label="昨日访客" width="55px" align="right" :key="1506" sortable> </el-table-column>

            <el-table-column prop="last90DayOrderRate" label="90日转化率" width="55px" align="right" :key="1217" sortable>
              <template v-slot="scope">
                <div>{{ scope.row.last90DayOrderRate >= 0 ? (Math.round(scope.row.last90DayOrderRate * 10000) / 100).toFixed(2) + "%" : "" }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="last30DayOrderRate" label="30日转化率" width="55px" align="right" :key="1218" sortable>
              <template v-slot="scope">
                <div>{{ scope.row.last30DayOrderRate >= 0 ? (Math.round(scope.row.last30DayOrderRate * 10000) / 100).toFixed(2) + "%" : "" }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="last14DayOrderRate" label="14日转化率" width="55px" align="right" :key="1219" sortable>
              <template v-slot="scope">
                <div>{{ scope.row.last14DayOrderRate >= 0 ? (Math.round(scope.row.last14DayOrderRate * 10000) / 100).toFixed(2) + "%" : "" }}</div>
              </template>
            </el-table-column>
          </template>
          <el-table-column prop="last7DayOrderRate" label="7日转化率" width="55px" align="right" :key="12111" sortable>
            <template v-slot="scope">
              <div>{{ scope.row.last7DayOrderRate >= 0 ? (Math.round(scope.row.last7DayOrderRate * 10000) / 100).toFixed(2) + "%" : "" }}</div>
            </template>
          </el-table-column>
          <template v-if="viewModel == 2">
            <el-table-column prop="last2DayOrderRate" label="2日转化率" width="55px" align="right" :key="12112" sortable>
              <template v-slot="scope">
                <div>{{ scope.row.last2DayOrderRate >= 0 ? (Math.round(scope.row.last2DayOrderRate * 10000) / 100).toFixed(2) + "%" : "" }}</div>
              </template>
            </el-table-column>

            <el-table-column prop="lastDayOrderRate" label="昨日转化率" width="55px" align="right" :key="15113" sortable>
              <template v-slot="scope">
                <div>{{ scope.row.lastDayOrderRate >= 0 ? (Math.round(scope.row.lastDayOrderRate * 10000) / 100).toFixed(2) + "%" : "" }}</div>
              </template>
            </el-table-column>
          </template>
          <el-table-column prop="price" label="价格" width="50px" align="right" :key="125" sortable> </el-table-column>

          <el-table-column prop="rank" label="排名" width="60px" align="right" :key="122" sortable> </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination ref="pageNav" layout="prev, pager, next, total" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"></el-pagination>
      </div>
    </div>
    <el-dialog title="导入" :visible.sync="dialogFormVisible" width="35%">
      <el-form :model="form">
        <el-form-item label="导入订单" label-width="80">
          <el-upload ref="uploadOrder" class="upload-demo" action="/node/importOrder" :data="{ shopType }" :auto-upload="false" :on-success="onUploadSuccess" :before-upload="beforeUpload" :limit="1">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="importData">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导出" :visible.sync="dialogProductVisible" width="25%">
      <el-form :model="form">
        <el-form-item label="库存规划" label-width="80">
          <el-button type="primary" size="small">
            <!-- <download-excel :data="exportBusinessDataList" :fields="exportTitles" :name="getExportName()">导出库存</download-excel> -->
          </el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogProductVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="生成计划" :visible.sync="createInventoryVisible" width="650px" :close-on-click-modal="false">
      <div class="form-line">
        <span class="form-label"><span>*</span>计划日期</span>
        <el-date-picker v-model="createPlanDate" type="date" placeholder="选择日期" size="small" value-format="yyyy-MM-dd" style="margin-left: 20px"></el-date-picker>
        <!-- <span class="form-tip">按北京时间对应美国站点日期，默认规则与经营数据页一致</span> -->
      </div>
      <div class="form-line">
        <span class="form-label">店铺</span>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" style="margin-left: 20px; margin-right: 20px">全选</el-checkbox>
        <el-checkbox-group v-model="checkedShopTypes" @change="handleCheckedCitiesChange" style="display: inline-block; width: 400px">
          <el-checkbox v-for="shopType in shopTypes" :label="shopType" :key="shopType">{{ getShopName(shopType) }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="createInventoryVisible = false">取消</el-button>
        <el-button class="opreate-btn" type="primary" size="small" @click="handleCreateInventory">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="生产出库单" :visible.sync="createOutStockVisible" width="480px" :close-on-click-modal="false">
      <div class="form-line">
        <span class="form-label"><span>*</span>出库日期</span>
        <el-date-picker v-model="createOutStockDate" type="date" placeholder="选择日期" size="small" value-format="yyyy-MM-dd" style="margin-left: 20px"></el-date-picker>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="createOutStockVisible = false">取消</el-button>
        <el-button class="opreate-btn" type="primary" size="small" @click="createOutStoctPlan">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { activeProducts, colors, models } from "../../utils/constant.js";
import Utils from "../../utils/utils.js";

export default {
  data() {
    return {
      shopType: localStorage.getItem("shopType"),
      total: 0,
      pageCount: 1,
      productList: activeProducts,
      colorList: colors,
      modelList: models,
      dialogFormVisible: false,
      dialogProductVisible: false,
      createInventoryVisible: false,
      createPlanDate: Utils.getDefaultAmericaBusinessDate(),
      createOutStockVisible: false,
      createOutStockDate: new Date().format("yyyy-MM-dd"),
      form: {
        file: null,
        type: 0,
      },
      totalPage: 1,
      businessDataList: [],
      exportBusinessDataList: [],
      dateList: [],
      activeRowIndex: -1,
      activeColumnIndex: -1,
      productModel: "",
      params: {
        funType: "",
        sku: "",
        sortKey: "planPurchase",
        sortType: "-1",
        fulfillmentChannel: "AMAZON_NA",
        viewType: "2",
        productType: "",
        productColor: "",
        date: new Date(new Date().getTime()).format("yyyy-MM-dd"),
        listShowType: "3",
        productModel: "",
        beginIndex: 0,
        viewModel: "1",
        purchaseStatus: "",
        pageSize: 10000,
      },
      uploadCount: 0,
      screenHeight: 400,
      multipleSelection: [],
      isSelectModel: false,
      selectRows: [],
      loading: true,
      viewModel: 1,
      funType: this.$route.meta.type || (this.$route.path.includes("outStock") ? "outStock" : "purchase"),
      checkedShopTypes: [],
      checkAll: false,
      isIndeterminate: true,
      shopTypes: [1, 2, 3, 4, 8],
      shops: [
        { shopType: 1, shopName: "灵柚" },
        { shopType: 2, shopName: "萧发" },
        { shopType: 3, shopName: "誉腾" },
        { shopType: 4, shopName: "甄昂" },
        { shopType: 8, shopName: "众联" },
      ],
    };
  },
  watch: {
    "$route.path"() {
      this.syncFunTypeAndReload();
    },
    "params.productType": {
      handler: function (newValue, oldValue) {
        let parentProduct = this.productList.find(pd => pd.productType == newValue);
        let checkColors = Array.isArray(parentProduct.checkColors) ? parentProduct.checkColors : JSON.parse(parentProduct.checkColors);
        let checkModels = Array.isArray(parentProduct.checkModels) ? parentProduct.checkModels : JSON.parse(parentProduct.checkModels);

        this.colorList = [];
        this.modelList = [...checkModels];

        colors.forEach(color => checkColors.includes(color.key) && this.colorList.push(color));
      },
    },
    "params.viewModel": {
      handler(val, olVal) {
        // this.initDateList();
      },
      deep: true,
    },
    productModel: {
      handler: function (newValue, oldValue) {
        let blankReg = new RegExp(" ", "igm");
        let productModel = newValue.replace(blankReg, "");
        this.params.productModel = productModel;
      },
    },
    "params.viewType": {
      handler: function (newValue, oldValue) {
        this.params.pageSize = newValue == 1 ? 50 : 10000;

        this.params.beginIndex = 0;
        this.getData();
        // console.log(this.params.viewType);
      },
      deep: true,
    },
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  created() {
    this.params.funType = this.funType;
  },
  mounted() {
    this.getData();
    this.calculateHeight();
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    resolveFunType() {
      const path = (this.$route && this.$route.path) || "";
      if (path.indexOf("/outStockPlanMgmt") !== -1) {
        return "outStock";
      }
      return "purchase";
    },
    syncFunTypeAndReload() {
      const next = this.funType;
      if (this.params.funType === next) {
        return;
      }
      this.params.funType = next;
      this.params.beginIndex = 0;
      this.multipleSelection = [];
      this.getData();
    },
    calculateHeight() {
      this.$nextTick(() => {
        const panel = this.$refs.tablePanel;
        if (!panel) {
          return;
        }
        const pagination = panel.querySelector(".pagination-box");
        const panelStyle = window.getComputedStyle(panel);
        const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
        const paginationHeight = pagination ? pagination.offsetHeight : 0;
        const availableHeight = panel.clientHeight - paddingTop - paddingBottom - paginationHeight - 12;
        this.screenHeight = Math.max(availableHeight, 200);
      });
    },
    getShopName(shopType) {
      let shopName = "";
      shopType == 1 && (shopName = "灵柚");
      shopType == 2 && (shopName = "萧发");
      shopType == 3 && (shopName = "誉腾");
      shopType == 4 && (shopName = "甄昂");
      shopType == 8 && (shopName = "众联");
      return shopName;
    },
    handleCheckAllChange(val) {
      this.checkedShopTypes = val ? this.shopTypes : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.shopTypes.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.shopTypes.length;
    },
    openCreateInventoryDialog() {
      this.createPlanDate = Utils.getDefaultAmericaBusinessDate();
      this.createInventoryVisible = true;
    },
    handleCreateInventory() {
      if (!this.createPlanDate) {
        this.$message.error("请选择计划日期");
        return;
      }
      if (!this.checkedShopTypes || this.checkedShopTypes.length === 0) {
        this.$message.error("请至少选择一个店铺");
        return;
      }
      this.createInventoryData();
    },
    handleLongPress(event) {
      console.log(event.type);
      this.isSelectModel = event.type == "mousedown";
      // this.$refs.table.toggleRowSelection(this.clickRow, true);
    },
    handleMouseEnter(row, column, cell, event) {
      this.clickRow = row;
      if (!this.isSelectModel) {
        return;
      }
      // this.$refs.table.toggleRowSelection(row, true);
    },
    handleCellClick(row, column, cell, event) {
      let property = column.property;
      if (property != "planPurchaseAdjust" && property != "planPurchase" && property != "manualDayOrderAdjust") {
        return;
      }
      if (this.params.viewType != 1) {
        return;
      }

      let params = {
        _id: row._id,
      };

      this.$prompt("请输入" + column.label + "数量", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // inputPattern: /^\d+$/,
        inputErrorMessage: "请输入正确的数量",
        inputValue: row[property],
      })
        .then(({ value }) => {
          params[property] = value;
          if (property == "planPurchaseAdjust") {
            requestModules.updatePlanPurchaseAdjust(params).then(res => {
              this.$message({
                type: "success",
                message: "修改完成",
              });
              this.getData();
            });
          } else if (property == "planPurchase") {
            requestModules.addOrUpdatePurchasePlan(params).then(res => {
              this.$message({
                type: "success",
                message: "修改完成",
              });
              this.getData();
            });
          } else if (property == "manualDayOrderAdjust") {
            requestModules.updateDayOrderAdjust(params).then(res => {
              this.$message({
                type: "success",
                message: "修改完成",
              });
              this.getData();
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    queryBtn() {
      this.getData();
    },
    importBtn() {
      this.dialogFormVisible = true;
    },
    exportProductBtn() {
      this.dialogProductVisible = true;

      requestModules.updateProductRank(this.params).then(res => {});
    },
    addPurchase() {
      let params = {
        ...this.params,
      };
      let selectedList = [];
      this.multipleSelection.forEach(item =>
        selectedList.push({
          productType: item.productType,
          productColor: item.productColor,
          model: item.model,
        })
      );
      params.selectedList = JSON.stringify(selectedList);

      this.$confirm("是否加入采购", "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        requestModules.addToPurchases(params).then(res => {
          this.$confirm("添加完成", "提示", {
            confirmButtonText: "确定",
            type: "info",
          }).then(() => {
            this.getData();
          });
        });
      });
    },
    addPurchaseRecord() {
      let params = {
        ...this.params,
      };
      let selectedList = [];
      this.multipleSelection.forEach(item =>
        selectedList.push({
          productType: item.productType,
          productColor: item.productColor,
          model: item.model,
        })
      );
      params.selectedList = JSON.stringify(selectedList);

      this.$confirm("是否加入采购记录", "提示", {
        confirmButtonText: "确定",
        type: "info",
      }).then(() => {
        requestModules.addToPurchaseRecords(params).then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "加入采购记录失败");
            return;
          }
          const added = (res.mdata && res.mdata.added) || 0;
          const tip = res.message || (added > 0 ? `成功加入 ${added} 条采购记录` : "添加完成");
          this.$confirm(tip, "提示", {
            confirmButtonText: "确定",
            type: "info",
          }).then(() => {
            this.getData();
          });
        });
      });
    },
    batchUpdatePlanPurchaseAdjust() {
      if (this.params.viewType != 1) {
        this.$message.warning("请在SKU视图下批量修改采购手工调整");
        return;
      }
      if (!this.multipleSelection.length) {
        return;
      }
      this.$prompt("请输入采购手工调整数量", "批量修改采购手工调整", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputErrorMessage: "请输入正确的数量",
        inputValue: "0",
      })
        .then(({ value }) => {
          if (value === "" || value == null) {
            this.$message.error("请输入采购手工调整数量");
            return;
          }
          let requests = this.multipleSelection.map(row =>
            requestModules.updatePlanPurchaseAdjust({
              _id: row._id,
              planPurchaseAdjust: value,
            })
          );
          Promise.all(requests)
            .then(results => {
              let failedCount = results.filter(res => !res || res.result !== 1).length;
              if (failedCount) {
                this.$message.error(`有 ${failedCount} 条修改失败`);
              } else {
                this.$message.success("修改完成");
              }
              this.getData();
            })
            .catch(() => {
              this.$message.error("批量修改失败");
            });
        })
        .catch(() => {});
    },

    createPurchasePlan() {
      requestModules.createPurchasePlan({ funType: this.funType }).then(res => {
        this.$confirm("生产完成", "提示", {
          confirmButtonText: "确定",
          type: "info",
        }).then(() => {
          this.getData();
        });
      });
    },
    openCreateOutStockDialog() {
      this.createOutStockDate = new Date().format("yyyy-MM-dd");
      this.createOutStockVisible = true;
    },
    createOutStoctPlan() {
      if (!this.createOutStockDate) {
        this.$message.error("请选择出库日期");
        return;
      }
      const date = this.createOutStockDate;
      this.createOutStockVisible = false;
      requestModules
        .createOutStockPlan({ date })
        .then(res => {
          this.$confirm("生产完成", "提示", {
            confirmButtonText: "确定",
            type: "info",
          }).then(() => {
            this.getData();
          });
        })
        .catch(err => {
          this.$message.error((err && err.message) || "生产出库单失败");
        });
    },
    createInventoryData() {
      this.createInventoryVisible = false;
      requestModules
        .createInventoryData({
          funType: this.funType,
          shopTypes: JSON.stringify(this.checkedShopTypes),
          date: this.createPlanDate,
        })
        .then(res => {
          this.$confirm("生产完成", "提示", {
            confirmButtonText: "确定",
            type: "info",
          }).then(() => {
            this.getData();
          });
        });
    },
    importData() {
      this.dialogFormVisible = false;

      this.$refs.uploadOrder.uploadFiles.length > 0 && this.$refs.uploadOrder.submit();
    },
    beforeUpload() {
      this.uploadCount++;
      console.log("beforeUpload", this.uploadCount);
    },
    onUploadSuccess(text) {
      this.uploadCount--;
      console.log("onUploadSuccess", this.uploadCount);

      if (this.uploadCount == 0) {
        this.$confirm("导入完成", "提示", {
          confirmButtonText: "确定",
          type: "info",
        }).then(() => {
          this.clearUploadedFiles();
        });
      }
    },
    clearUploadedFiles() {
      this.$refs.uploadOrder.uploadFiles.length > 0 && this.$refs.uploadOrder.clearFiles();
    },
    getExportName() {
      return "库存规划表_" + new Date().format("yyyy-MM-dd_hh:mm:ss");
    },
    productDetail(row) {
      window.open("/client/parentProductAnalysis?productType=" + row.productType);
    },
    goAdvert(row) {
      window.open("/client/advertMgmt?asin=" + row.asin1);
    },
    goDataDictionary() {
      window.open("/client/purchaseMgmt/dataDictionary");
    },
    getData() {
      this.loading = true;
      requestModules
        .fetchPurchasePlans(this.params)
        .then(res => {
          this.businessDataList = res.ldata || [];
          this.total = res.total || 0;
        })
        .finally(() => {
          this.loading = false;
          this.calculateHeight();
        });
    },
    // initDateList(businessDate) {
    //   this.dateList = [];
    //   let dateLength = this.params.viewModel == 1 ? 8 : 30;
    //   if (businessDate) {
    //     for (let i = 0; i < dateLength; i++) {
    //       let date = new Date(new Date(businessDate) - i * 24 * 60 * 60 * 1000).format("MM-dd");
    //       this.dateList.push(date);
    //     }
    //   } else {
    //     let hours = new Date().getHours();
    //     let offset = 0;
    //     let usaFirstHour = 16;
    //     Utils.isDaylightSavingTime() && (usaFirstHour = 15);
    //     hours < usaFirstHour && (offset = 1);
    //     if (hours < usaFirstHour) {
    //       this.params.date = new Date(new Date().getTime() - offset * 24 * 60 * 60 * 1000).format("yyyy-MM-dd");
    //     }

    //     for (let i = 0; i < dateLength; i++) {
    //       let date = new Date(new Date().getTime() - (i + offset) * 24 * 60 * 60 * 1000).format("MM-dd");
    //       this.dateList.push(date);
    //     }
    //   }
    // },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getData();
    },
    handleCellMouseEnter(row, column, cell, event) {
      this.activeRowIndex = cell.parentNode.rowIndex;
      this.activeColumnIndex = cell.cellIndex;
    },
    handleCellMouseLeave() {
      this.activeRowIndex = -1;
      this.activeColumnIndex = -1;
    },
    getSummaries(param) {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
      const { columns, data } = param;
      const sums = [];
      const orderRateMap = {
        last90DayOrderRate: { orders: "last90DayOrderItems", visits: "last90DayVisits" },
        last30DayOrderRate: { orders: "last30DayOrderItems", visits: "last30DayVisits" },
        last14DayOrderRate: { orders: "last14DayOrderItems", visits: "last14DayVisits" },
        last7DayOrderRate: { orders: "last7DayOrderItems", visits: "last7DayVisits" },
        last2DayOrderRate: { orders: "last2DayOrderItems", visits: "last2DayVisits" },
        lastDayOrderRate: { orders: "lastDayOrderItems", visits: "lastDayVisits" },
      };
      const skipSumProps = new Set(["last90DayOrderRate", "last30DayOrderRate", "last14DayOrderRate", "last7DayOrderRate", "last2DayOrderRate", "lastDayOrderRate", "inventoryDay", "availableInventoryDay", "amazonStockCycle", "firstLegStockCycle", "localStockCycle", "price", "rank", "stockCycleType"]);
      const textLabels = new Set(["补货物流", "备货类型", "SKU", "名称", "机型", "颜色"]);
      const rateTotals = {};

      Object.values(orderRateMap).forEach(({ orders, visits }) => {
        rateTotals[orders] = data.reduce((sum, item) => sum + (Number(item[orders]) || 0), 0);
        rateTotals[visits] = data.reduce((sum, item) => sum + (Number(item[visits]) || 0), 0);
      });

      const dayOrderItems = data.reduce((sum, item) => sum + (Number(item.dayOrderItems) || 0), 0);
      const totalInventory = data.reduce((sum, item) => sum + (Number(item.totalInventory) || Number(item.allInventory) || 0), 0);
      const availableInventory = data.reduce((sum, item) => sum + (Number(item.availableInventory) || Number(item.availableQuantity) || 0), 0);

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (textLabels.has(column.label) || !column.property || skipSumProps.has(column.property)) {
          sums[index] = "";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            return !isNaN(value) ? prev + value : prev;
          }, 0);
        } else {
          sums[index] = "";
        }
        if (column.property === "dayOrderItems" || column.property === "manualDayOrderAdjust") {
          sums[index] !== "" && (sums[index] = Number(sums[index]).toFixed(2));
        }
      });

      columns.forEach((column, index) => {
        const rateConfig = orderRateMap[column.property];
        if (rateConfig) {
          const visits = rateTotals[rateConfig.visits];
          const orders = rateTotals[rateConfig.orders];
          sums[index] = visits > 0 ? (Math.round((orders / visits) * 10000) / 100).toFixed(2) + "%" : "";
        }
        if (column.property === "inventoryDay") {
          sums[index] = dayOrderItems > 0 ? Math.round(totalInventory / dayOrderItems) : "";
        }
        if (column.property === "availableInventoryDay") {
          sums[index] = dayOrderItems > 0 ? Math.round(availableInventory / dayOrderItems) : "";
        }
      });

      return sums;
    },
    getInventoryDayStyleClass(row) {
      let styleClass = "";
      let inventoryDay = row.inventoryDay;
      if (this.params.viewType == 1) {
        let firstLegStockCycle = row.firstLegStockCycle;
        let amazonStockCycle = row.amazonStockCycle;
        let stockCycle = firstLegStockCycle + amazonStockCycle;
        let stockDay = stockCycle * 7;

        inventoryDay <= stockDay / 2 && (styleClass = "redBg");
        inventoryDay > stockDay / 2 && inventoryDay <= stockDay && (styleClass = "yellowBg");
        inventoryDay > stockDay && inventoryDay <= 90 && (styleClass = "greenBg");
        inventoryDay > 90 && (styleClass = "redText");
      } else {
        inventoryDay <= 15 && (styleClass = "redBg");
        inventoryDay > 15 && inventoryDay <= 30 && (styleClass = "yellowBg");
        inventoryDay > 30 && inventoryDay <= 90 && (styleClass = "greenBg");
        inventoryDay > 90 && (styleClass = "redText");
      }
      return styleClass;
    },
    getAvailableInventoryDayStyleClass(row) {
      let styleClass = "";
      let inventoryDay = row.availableInventoryDay;
      // if (row.productName == "波浪闪粉") {
      //   debugger;
      // }
      if (this.params.viewType == 1) {
        let stockCycle = row.amazonStockCycle;
        let stockDay = stockCycle * 7;

        inventoryDay <= stockDay / 2 && (styleClass = "redBg");
        inventoryDay > stockDay / 2 && inventoryDay <= stockDay && (styleClass = "yellowBg");
        inventoryDay > stockDay && inventoryDay <= 60 && (styleClass = "greenBg");
        inventoryDay > 60 && (styleClass = "redText");
      } else {
        inventoryDay <= 10 && (styleClass = "redBg");
        inventoryDay > 10 && inventoryDay <= 20 && (styleClass = "yellowBg");
        inventoryDay > 20 && inventoryDay <= 60 && (styleClass = "greenBg");
        inventoryDay > 60 && (styleClass = "redText");
      }
      return styleClass;
    },
    getRecommendPriceStyleClass(row) {
      let styleClass = "";
      row.recommendPrice - row.price > 0 && (styleClass = "greenBg");
      row.recommendPrice - row.price < 0 && (styleClass = "redBg");
      return styleClass;
    },
    getInventoryAgeStyleClass(inventoryAge91To180Days) {
      let styleClass = "";
      inventoryAge91To180Days > 0 && (styleClass = "redBg");
      return styleClass;
    },
    getSellThroughStyleClass(sellThrough) {
      let styleClass = "";
      sellThrough < 1 && (styleClass = "redBg");
      sellThrough >= 1 && sellThrough <= 2 && (styleClass = "yellowBg");
      sellThrough > 2 && (styleClass = "greenBg");
      return styleClass;
    },
    getLogisticsTypeLabel(logisticsType) {
      let label = "";
      logisticsType == 1 && (label = "红单快递");
      logisticsType == 2 && (label = "美森正班");
      logisticsType == 3 && (label = "海派海卡");
      return label;
    },
    getStockCycleTypeLabel(stockCycleType) {
      let label = "默认平销";
      stockCycleType == 1 && (label = "平销");
      stockCycleType == 2 && (label = "做排名");
      stockCycleType == 3 && (label = "新品推广");
      stockCycleType == 4 && (label = "清库存");
      stockCycleType == 5 && (label = "禁止采购");
      stockCycleType == 6 && (label = "禁止出库");
      return label;
    },
  },
  computed: {
    funType() {
      return this.resolveFunType();
    },
    highlightCellStyle() {
      return {
        backgroundColor: "yellow",
      };
    },
    tableData() {
      return this.businessDataList;
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

#PurchasePlanMgmt.purchase-plan-mgmt-page {
  .header-box {
    padding: 10px;
    height: auto;

    .filter-input-wide {
      width: 160px;
    }

    .filter-toolbar {
      margin-top: 4px;
      padding-top: 10px;
      border-top: 1px dashed #ebeef5;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .filter-actions .el-button {
      width: auto;
      min-width: auto;
      margin: 0;
    }
  }

  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;
    text-align: right;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
    .greenText {
      color: green;
    }
    .greenYellowText {
      color: rgb(233, 104, 104);
    }
    .yellowText {
      color: rgb(112, 56, 56);
    }
  }

  .el-table tr:hover {
    background-color: #f9f981;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table .current-row {
    background-color: #f9f981;

    .el-table__cell {
      background-color: #f9f981;
    }
  }

  .upload-demo {
    text-align: right;
  }

  .form-line {
    margin-bottom: 12px;

    .form-label {
      display: inline-block;
      width: 80px;
      text-align: right;
      vertical-align: middle;

      span {
        color: #f56c6c;
      }
    }

    .form-tip {
      margin-left: 12px;
      color: #909399;
      font-size: 12px;
      vertical-align: middle;
    }
  }
}
</style>
